import type { UrlMapFn, UrlMap, PageTypeKey, UrlObj } from '@/config/types';

import BaseUrlPackage from '@/core/url-package';
import { getMappingPage, getUrlAndQueryFromUrl } from '@/util';
import { uuid } from '@/util/uuid';
import ssrGlobal from '@/util/ssr-global';

export default class UrlPackage extends BaseUrlPackage {
    sampled?: boolean | {radar: {[key: string]: number}};
    constructor(url: string | UrlObj, pageType: PageTypeKey, urlMap?: UrlMap | UrlMapFn) {
        super({}, pageType);
        if (typeof url === 'string') {
            // TODO: 避免兼容问题，暂不处理
            // try {
            //     url = window.decodeURIComponent(url);
            // } catch (err) {}
            const obj = getUrlAndQueryFromUrl(url);
            this.page = obj.page;
            this.params = obj.params;
        } else {
            this.page = (url || {}).page || '';
            this.params = (url || {}).params || undefined;
        }
        this.identity = this.generatePageId();
        if (urlMap && typeof url === 'string') {
            this.init(url, urlMap);
        }
    }

    init(url: string, urlMap: UrlMap | UrlMapFn = {}) {
        const { page, params } = getMappingPage({url, page: this.page, params: this.params}, urlMap);
        this.update(page, params);
    }

    attachUrl() {
        if (!this.params) {
            this.params = {};
        }
        if (location?.href) {
            // 电商需求，页面信息携带原始 url 和 pathname
            this.params.origin_url = this.params.origin_url || ssrGlobal.location?.href;
            const { page = '' } = getUrlAndQueryFromUrl(ssrGlobal.location.href);
            this.params.origin_pathname = page;
        }
    }

    getRealUrlPackage() {
        const { page, params } = getUrlAndQueryFromUrl(ssrGlobal.location.href);
        return {
            page,
            params: {
                page_code: this.page,
                url: ssrGlobal.location.href,
                query: params,
                ...params
            },
            page_type: this.page_type,
            identity: this.identity
        };
    }

    override generatePageId() {
        return uuid();
    }

}
